export const EventHostSponsorEnum = {
  wsg: "WSG Host",
  wsgMember: "WSG Host and Member Sponsor",
  group: "WSG Group Sponsor",
  groupMember: "WSG Group and Member Sponsor",
  member: "Member Sponsor",
  industry: "Industry Event",
  wsgGuest: "WSG and Guest Sponsor",
  guest: "Guest Sponsor",
};

export const EventTypeEnum = {
  inPerson: "In Person",
  virtual: "Virtual",
  hybrid: "Hybrid",
};

export const StatusEnum = {
  private: "Private Online",
  online: "Live Online",
  offline: "Offline",
};

export const TabEnum = {
  registration: "Registration",
  program: "Program",
  accomodation: "Accommodations",
  specialEvent: "Special Event",
  overview: "Overview",
  gallery: "Photo Gallery",
  attendees: "Attendees",
  contactUs: "Contact Us",
} as const;

export const TabRoutes: Record<TabType, string> = {
  registration: "registration",
  accomodation: "accommodations",
  specialEvent: "special-event",
  overview: "overview",
  gallery: "gallery",
  attendees: "attendees",
  contactUs: "contact-us",
  program: "program",
};

/** Standalone page reached from the Attendees tab; not a configurable event tab. */
export const NetworkingMapRoute = "connections";

export const PublicTabs: TabType[] = ["overview", "contactUs"];
export const MemberOnlyTabs: TabType[] = [
  "accomodation",
  "specialEvent",
  "gallery",
  "attendees",
  "registration",
  "program",
];

export const RegistrationChildRoutes = {
  payment: "payment",
  confirmation: "confirmation",
  success: "success",
} as const;

export type RegistrationChildRouteType = keyof typeof RegistrationChildRoutes;

export const ProgramTypeEnum = {
  session: "Session",
  break: "Break",
  lunch: "Lunch",
  dinner: "Dinner",
  networking: "Networking",
  other: "Other",
};

export const SpeakerTypeEnum = {
  speaker: "Speaker",
  keynote: "Keynote Speaker",
  guest: "Guest Speaker",
  moderator: "Moderator",
  panelist: "Panelist",
};

export const SetupTypeEnum = {
  annual: "Annual Meeting",
  luncheon: "Luncheon",
  regional: "Regional Meeting",
  cocktail: "Cocktail Reception",
  group: "Group Meeting",
  groupWebinar: "Group Meeting Webinar",
  seminar: "Seminar",
  networking: "Social Networking",
  webinar: "Webinar",
  general: "General Meeting",
  specialEvent: "Special Event",
  learning: "Learning Institute Course",
  dinner: "Dinner",
  podcast: "Podcast",
  practice: "Practice Meeting",
  online: "Online Event",
  reception: "Reception",
} as const;

export const SetupTypeDisplay: Record<keyof typeof SetupTypeEnum, string> = {
  annual: "Annual",
  luncheon: "Luncheon",
  regional: "Regional",
  cocktail: "Cocktail",
  group: "Group",
  groupWebinar: "Group",
  seminar: "Seminar",
  networking: "Networking",
  webinar: "Webinar",
  general: "General",
  specialEvent: "Special",
  learning: "Learning",
  dinner: "Dinner",
  podcast: "Podcast",
  practice: "Practice",
  online: "Online",
  reception: "Reception",
};

export function getSetupTypeDisplay(raw: string | null | undefined): string {
  if (raw == null || raw === "") {
    return "";
  }
  const key =
    (SetupTypeDisplay as Record<string, string>)[raw] != null
      ? raw
      : (Object.entries(SetupTypeEnum).find(([, v]) => v === raw)?.[0] as keyof typeof SetupTypeEnum | undefined) ?? raw;
  return (SetupTypeDisplay as Record<string, string>)[key] ?? (SetupTypeEnum as Record<string, string>)[key] ?? raw;
}

export type EventHostSponsorType = keyof typeof EventHostSponsorEnum;
export type StatusType = keyof typeof StatusEnum;
export type EventType = keyof typeof EventTypeEnum;
export type TabType = keyof typeof TabEnum;
export type ProgramType = keyof typeof ProgramTypeEnum;
export type SpeakerType = keyof typeof SpeakerTypeEnum;
export type SetupType = keyof typeof SetupTypeEnum;
